import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { StyledSearchSuggestionContainer } from "../styled/home/stylesHome";
import Format from "string-format";
import { searchFormats } from "../../_actions/slidePresetActions";
import {TEMPLATES_BY_FORMAT_SCREEN} from "../../_utils/routes";
import { useHistory } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import * as ReactIcon from "react-icons/fa";
import {
  Flex,
  List,
  ListIcon,
  ListItem,
  Skeleton,
  Stack,
  Text,
  Box
} from "@chakra-ui/react";
import { TEMPLATES_SEARCH_TAGS_SUGGESTIONS_ENDPOINT } from "../../_actions/endpoints";
import axios from "axios";
import { useTranslation } from "react-i18next";

const listItemStyles = {
  direction: "row",
  alignItems: "center",
  _hover: {
    backgroundColor: "brand.dark_02",
    cursor: "pointer",
  },
  padding: "0.5rem 1rem",
};

const TldrSearchSuggestion = (props) => {
  const { t } = useTranslation(["common"]);
  const {
    searchTerm,
    searchLocation,
    width,
    classes,
    handleShowAllClick,
    searchInFormats,
  } = props;

  const history = useHistory();
  const dispatch = useDispatch();
  const slidePresets = useSelector((state) => state.slidePresets);
  const { presets } = slidePresets;

  const [tagSuggestionsResult, setTagSuggestionsResult] = useState([]);
  const [loadingSuggestions, setLoadingSuggestions] = useState(false);

  useEffect(() => {
    if (searchInFormats) {
      handleSearchFormats(searchTerm);
    }

    if (searchTerm.length > 0) {
      getTemplateSearchTagSuggestions(searchTerm);
    }

    return () => {};
  }, [searchTerm]);

  function handleSearchFormats(key = "") {
    dispatch(
      searchFormats(key, {
        slidePresets,
        ...props,
      })
    );
  }

  function getTemplateSearchTagSuggestions(searchTerm) {
    const url = Format(TEMPLATES_SEARCH_TAGS_SUGGESTIONS_ENDPOINT, searchTerm);
    setLoadingSuggestions(true);
    axios.get(url).then((res) => {
      setTagSuggestionsResult(res.data.tag_suggest__completion[0].options);
      setLoadingSuggestions(false);
    });
  }

  function handlePresetClick(preset) {
    const url = Format(TEMPLATES_BY_FORMAT_SCREEN, preset?.title);

    history.push({
      pathname: encodeURI(url),
      search: "",
    });
    // history.go(0);
  }

  function handleShowAllOnClick() {
    if (handleShowAllClick) {
      handleShowAllClick(searchTerm);
    }
  }

  function handleSuggestionOnClick(suggestionText) {
    if (handleShowAllClick) {
      handleShowAllClick(suggestionText);
    }
  }

  return (
    <Box display={["none","none","none","block"]} >
    <StyledSearchSuggestionContainer
      width={width}
      location={searchLocation}
    >
      <div className="suggestion-box">
        {/* suggestions */}
        {!loadingSuggestions && tagSuggestionsResult.length > 0 ? (
          <List>
            {tagSuggestionsResult.map((suggestion, index) => (
              <ListItem
                key={index}
                as={Flex}
                sx={listItemStyles}
                onClick={() => handleSuggestionOnClick(suggestion.text)}
              >
                <ListIcon as={FaSearch} mr={3} />
                <Text>{suggestion.text}</Text>
              </ListItem>
            ))}
          </List>
        ) : loadingSuggestions ? (
          <Stack px="1rem" py="0.5rem">
            <Skeleton height="20px" />
            <Skeleton height="20px" />
          </Stack>
        ) : null}

        {/* search for the text */}
        {searchTerm?.length > 0 && (
          <div className="show-all-item" onClick={handleShowAllOnClick}>
            <span>
              <FaSearch />
            </span>

            <div>
              <p className="title">{t("search.show_all")}</p>
              <p className="searched-keyword">{searchTerm}</p>
            </div>
          </div>
        )}

        {/* search for the text in formats */}
        {searchInFormats ? (
          <>
            <p className="title">{t("search.suggested_formats")}</p>
            {presets.length > 0 ? (
              <List>
                {presets.map((preset, index) => (
                  <ListItem
                    key={index}
                    as={Flex}
                    direction="row"
                    align="center"
                    sx={{
                      _hover: {
                        backgroundColor: "brand.dark_02",
                        cursor: "pointer",
                      },
                    }}
                    px="1rem"
                    py="0.5rem"
                    onClick={() => handlePresetClick(preset)}
                  >
                    <ListIcon
                      as={
                        preset?.payload?.icon
                          ? ReactIcon[preset.payload.icon]
                          : ReactIcon.FaPencilAlt
                      }
                      mr={3}
                    />
                    <Flex direction="row" align="center">
                      <Text>{preset.display_name}</Text>
                      <Text color="gray.300" fontSize="14px" ml="0.25rem">
                        {preset.image_width} x {preset.image_height}
                      </Text>
                    </Flex>
                  </ListItem>
                ))}
              </List>
            ) : presets.length === 0 ? (
              <Text className="searched-keyword" px={4} pb={4}>
                {t("search.no_format")}
              </Text>
            ) : null}
          </>
        ) : null}
      </div>
    </StyledSearchSuggestionContainer>
    </Box>
  );
};

TldrSearchSuggestion.propTypes = {
  searchTerm: PropTypes.string.isRequired,
};

TldrSearchSuggestion.defaultProps = {
  width: "400px",
  searchTerm: "",
  searchInFormats: true,
};

export default TldrSearchSuggestion;
